//
//
//
//
//
//
//
//
import buttonBase from './_buttonBase';
export default {
  extends: buttonBase,
  data: function data() {
    return {
      displayName: this.button ? this.button.displayName : '',
      showingMessage: false,
      successMessage: this.button ? this.button.successMessage : '',
      successMessageDuration: this.button ? this.button.successMessageDuration : 5000,
      errorMessage: this.button ? this.button.errorMessage : '',
      errorMessageDuration: this.button ? this.button.errorMessageDuration : 5000,
      messageText: '',
      inputValue: window.location.href
    };
  },
  methods: {
    performAction: function performAction(event) {
      if (this.$_checkForprivacyOptOut(this.button) == true) {
        return;
      }

      event.stopPropagation();
      this.$_attemptCopy();
      this.$_raiseAnalyticsEvent('CopyRecipeLink');
      return true;
    },
    $_attemptCopy: function $_attemptCopy() {
      var _this = this;

      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.inputValue).then(function () {
          _this.$_showMessage(true);
        }, function () {
          _this.$_showMessage(false);
        });
      } // fallback
      else {
          var inputElement = this.$_getInputElement();
          inputElement.focus();
          inputElement.select();

          try {
            document.execCommand('copy');
            this.$_showMessage(true);
          } catch (err) {
            this.$_showMessage(false);
          }
        }
    },
    $_showMessage: function $_showMessage(success) {
      this.messageText = success ? this.successMessage : this.errorMessage;
      this.showingMessage = true;
      var duration = success ? this.successMessageDuration : this.errorMessageDuration;
      setTimeout(this.$_hideMessage, duration);
    },
    $_hideMessage: function $_hideMessage() {
      this.showingMessage = false;
    },
    $_getInputElement: function $_getInputElement() {
      /* istanbul ignore next */
      return this.$el.querySelector('#copyInput');
    }
  }
};